import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import moment from "moment";
import { FilterContext } from "../FilterContext";
import { initialWeekFilter } from "./FilterTypes/WeekFilterType";
import { PerWeek } from "../periodfilter/periodfiltersubperiod";

const WeekFilter = () => {
  const title = RESX.DateTime.Week;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("week", {
    getTitle: () => title,
    renderSelection: (filter) => <>
      {formatDate(filter.week)}
    </>,
    hasValue: (filter) => filter.week != null,
    reset: () => initialWeekFilter,
    areEqual: (a, b) => {
      if (a?.week == null && b?.week == null) return true;
      if (a?.week == null || b?.week == null) return false;
      return a?.week.startOf("week").isSame(b?.week.startOf("week"));
    }
  });
  useEffect(() => {
    setInitialValue("week", initialWeekFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [week, setWeek] = React.useState<moment.Moment>(initialWeekFilter.week);
  const [apply, setApply] = React.useState<boolean>(false);

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    const value = getValue("week");
    setWeek(value.week);
    setPopupOpen(true);
  };

  React.useEffect(() => {
    if (apply) {
      onApply();
      setApply(false);
      setPopupOpen(false);
    }
  }, [apply]);

  const onApply = (e?) => {
    e?.preventDefault();

    setValue("week", { week });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={(e) => { e.preventDefault(); setApply(true); }}>
        <div className="margin-bottom">
          <PerWeek
            initialStart={week}
            initialEnd={week}
            onChange={setWeek}
          />
        </div>
        <Button fluid primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default WeekFilter;

const formatDate = (date: moment.Moment) =>
  `${RESX.DateTime.Week} ${date.week()} ${date.format("YYYY")}`;
